import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_128: DocMigration = {
  maxSchemaVersion: "0.0.128",
  description: "Fascia size and soffit offset roof settings",
  apply(json: any) {
    const { settings: allSettings } = json;

    for (const settingsId in allSettings) {
      const settings = allSettings[settingsId];
      if (settings.type !== "ROOF_SETTINGS") {
        continue;
      }

      if (settings.fasciaBoardSize !== undefined) {
        settings.soffitOffset = settings.fasciaBoardSize - settings.fasciaSize;
        settings.fasciaSize = settings.fasciaBoardSize;
        delete settings.fasciaBoardSize;
      }
    }

    return json;
  },
};

export default migration_0_0_128;
